import { createContext, useContext } from 'react';

export enum GoogleTagManagerEventView {
  FRONT_PAGE_SCREENER = 'front-page-screener',
  ADVANCED_SCREENER = 'advanced-screener',
  CONSTITUENTS_SCREENER = 'constituents-screener',
  FUND_SCREENER = 'fund-screener',
  COMPANY = 'company',
  COMPANY_GROUP = 'company-group',
  PORTFOLIO = 'portfolio',
  // TODO Can this be removed?
  FACADE = 'facade',
  FOR_COMPANIES = 'for-companies',
  FOR_INVESTORS = 'for-investors',
  FREE_DMA_WAITLIST_V1 = 'free-dma-waitlist-v1',
  FREE_DMA_WAITLIST_V2 = 'free-dma-waitlist-v2',
  FREE_DMA_WAITLIST_PE_V1 = 'free-dma-waitlist-pe-v1',
}

type GtmEventEntityView =
  | GoogleTagManagerEventView.COMPANY
  | GoogleTagManagerEventView.COMPANY_GROUP
  | GoogleTagManagerEventView.PORTFOLIO;

type GtmEventGenericView = Exclude<GoogleTagManagerEventView, GtmEventEntityView>;

type GtmEventGenericContext = {
  view?: GtmEventGenericView;
};

type GtmEventEntityViewContext = {
  view: GtmEventEntityView;
  entityId: string;
  entityName: string | undefined;
};

export type GoogleTagManagerEventContext = GtmEventGenericContext | GtmEventEntityViewContext;

const ctx = createContext<GoogleTagManagerEventContext>({});
export function useGoogleTagManagerEventContext() {
  return useContext(ctx);
}

export const GoogleTagManagerEventContextProvider = ctx.Provider;
